<template>
  <el-drawer :visible.sync="visible" :show-close="true" :size="'40%'">
    <div slot="title" style="position: relative">
      <h2 class="info-title">详情</h2>
    </div>
    <div>
      <div style="padding: 20px;">
        <el-row :gutter="16">
          <el-col :span="6">
            <p>所属市场</p>
          </el-col>
          <el-col :span="10">
            <p class="content-item">
              {{ info.firmName }}
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <p>设备类型</p>
          </el-col>
          <el-col :span="10">
            <p class="content-item">
              {{ $u.dict.getDictName(info.deviceType, $u.dict.DeviceType) }}
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <p>app名称</p>
          </el-col>
          <el-col :span="10">
            <p class="content-item">{{ info.appName }}</p>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <p>版本号</p>
          </el-col>
          <el-col :span="10">
            <p class="content-item">{{ info.versionCode }}</p>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <p>版本名</p>
          </el-col>
          <el-col :span="10">
            <p class="content-item">{{ info.appVersion }}</p>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <p>下载链接</p>
          </el-col>
          <el-col :span="10">
            <p>
              <el-link
                :underline="false"
                type="primary"
                :href="getDownloadUrl(info.appUrl)"
                target="_blank"
                >{{ getDownloadUrl(info.appUrl) }}</el-link
              >
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <p>创建时间</p>
          </el-col>
          <el-col :span="10">
            <p class="content-item">{{ info.createTime }}</p>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <p>最后更新</p>
          </el-col>
          <el-col :span="10">
            <p class="content-item">{{ info.modifyTime }}</p>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <p>更新描述</p>
          </el-col>
          <el-col :span="10">
            <p class="content-item">{{ info.description }}</p>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import vControl from "@/api/version.control";
import dfs from "@/api/dfs";

export default {
  name: "VersionInfo",
  data() {
    return {
      versionId: "",
      visible: false,
      info: {}
    };
  },
  methods: {
    //初始化信息
    init(id) {
      this.versionId = id;
      this.visible = true;
      vControl.getOneById(this.versionId).then(result => {
        this.info = result.data;
      });
    },
    //获取下载链接
    getDownloadUrl(fileId) {
      return dfs.generateDownloadLink(fileId);
    }
  }
};
</script>

<style scoped lang="scss">
.content-item {
  color: #8c8c8c;
}
.info-title {
  &::after {
    position: absolute;
    content: "";
    width: 150%;
    height: 1px;
    background-color: #e8e8e8;
    bottom: 0;
    left: -20px;
  }
}
</style>
